<template>
  <div class="full-height-section">
    <h1 class="page-title">SEGUROS PARA BIENES</h1>
    <div class="services-row">
      <div
        v-for="(service, index) in services"
        :key="index"
        class="service-card"
        :style="{ backgroundImage: 'url(' + service.image + ')' }"
        @click="openModal(index)"
      >
        <div class="overlay"></div>
        <div class="service-content">
          <h2 class="service-title">{{ service.title }}</h2>
        </div>
      </div>
    </div>

  <!-- Modal personalizado -->
<div v-if="activeIndex !== null" class="custom-modal-overlay" @click.self="closeModal">
  <div class="custom-modal">
    <div class="custom-modal-header">
      <h5>{{ activeService.title }}</h5>
      <button class="close-btn" @click="closeModal">&times;</button>
    </div>

    <div class="custom-modal-body">
      <!-- Texto alineado a la izquierda -->
      <div class="modal-text">
        <p>{{ activeService.description }}</p>
      </div>

      <!-- Imagen centrada -->
      <div class="modal-image">
        <img
          v-if="activeService.image"
          :src="activeService.image"
          alt="Imagen seguro modal"
          class="modal-img"
        />
      </div>

      <button
        type="button"
        class="btn btn-warning mt-3"
        @click="irAFormulario"
      >
        Contratar Seguro
      </button>
    </div>
  </div>
</div>
</div>
</template>

<script>
export default {
  name: "ServiciosParaBienes",
  data() {
    return {
      services: [
        {
          title: "SEGURO DE AUTO",
          description:
            "Conduce con libertad y respaldo. Este seguro protege tu vehículo ante imprevistos como accidentes, robos, daños materiales o responsabilidad civil. Ideal si quieres cuidar tu patrimonio y contar con asistencia en carretera cuando más lo necesites.",
          image:
            "https://img.freepik.com/foto-gratis/mujer-petrificada-sintiendose-sorprendida-mientras-miraba-su-auto-danado-despues-accidente_637285-1087.jpg",
        },
        {
          title: "SEGURO DE CASA",
          description:
            "Tu hogar es mucho más que una propiedad. Es el espacio donde está todo lo que amas. Este seguro cuida tu vivienda y sus contenidos ante riesgos como incendios, robos o fenómenos naturales. Perfecto si buscas tranquilidad y protección completa para tu patrimonio.",
          image:
            "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1073&auto=format&fit=crop",
        },
        {
          title: "SEGURO DE EMBARCACIONES",
          description:
            "Diseñado para proteger tus embarcaciones recreativas o de trabajo ante daños, robos, responsabilidad civil o accidentes en el agua. Es esencial si navegas con frecuencia y deseas cuidar tu inversión mientras disfrutas del mar con seguridad.",
          image:
            "https://img.freepik.com/foto-gratis/detalle-exterior-embarcaciones_23-2150785208.jpg",
        },
      ],
      activeIndex: null,
    };
  },
  computed: {
    activeService() {
      return this.activeIndex !== null ? this.services[this.activeIndex] : {};
    },
  },
  methods: {
    openModal(index) {
      this.activeIndex = index;
    },
    closeModal() {
      this.activeIndex = null;
    },
    irAFormulario() {
      this.closeModal();
      this.$router.push("/formulario_contacto");
    },
  },
};
</script>

<style scoped>
.full-height-section {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  background-color: #233d72;
  padding: 0;
  color: white;
}

.page-title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 2.5rem;
  text-transform: uppercase;
  font-family: 'Open Sans', sans-serif;
}

.services-row {
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
  flex-wrap: wrap;
}

.service-card {
  position: relative;
  width: 33.3333%;
  height: 600px;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: fadeInUp 0.8s ease forwards;
  display: flex;
  align-items: flex-end;
  padding: 0;
}

.service-card:hover {
  transform: translateY(-10px) scale(1.05);
  box-shadow: 0 20px 30px rgba(0, 0, 0, 0.4);
  z-index: 2;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #233d7265;
  transition: background 0.3s ease;
}

.service-card:hover .overlay {
  background: rgba(0, 0, 0, 0.2);
}

.service-content {
  position: relative;
  z-index: 2;
  color: white;
  text-align: center;
  padding: 20px;
  width: 100%;
  font-family: 'Open Sans', sans-serif;
}

.service-title {
  font-size: 1.8rem;
  font-weight: bold;
  text-transform: uppercase;
  margin: 0;
}

@media (max-width: 992px) {
  .service-card {
    width: 100%;
    height: 400px;
  }
}

@media (max-width: 768px) {
  .service-title {
    font-size: 1.5rem;
  }
  .service-card {
    height: 300px;
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Estilos del modal personalizado */
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.custom-modal {
  background: #fff;
  color: #000;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

.custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
}

.custom-modal-body {
  display: flex;
  flex-direction: column;
}

.modal-text {
  text-align: left; /* ahora el texto queda alineado a la izquierda */
  margin-bottom: 15px;
}

.modal-image {
  text-align: center; /* imagen centrada */
  margin-bottom: 15px;
}

.modal-img {
  max-width: 200px;
  height: auto;
  border-radius: 5px;
  text-align: center; /* imagen centrada */
  margin-bottom: 15px;
}

.custom-modal-body .btn {
  min-width: 150px;
  width: fit-content;
  align-self: center;
}

.custom-modal-header h5 {
  margin: 0;
  text-align: center;
  flex: 1;
  line-height: 2.5; /* interlineado más cómodo */
}
.modal-text p {
  line-height: 1.6; /* interlineado en el texto */
  margin: 0 0 15px; /* espacio después del párrafo */
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
